const SCROLL_THRESHOLD = 100;

const scrollState = (lenis, $body) => {
	let isHeaderHidden = false;

	const update = () => {
		const scroll = lenis.scroll;
		const direction = lenis.direction;
		const isPastThreshold = scroll > SCROLL_THRESHOLD;
		const isMenuOpen = $body.hasClass('menu-open');

		$body.toggleClass('has-scrolled', isPastThreshold);

		if (isMenuOpen || scroll <= 0) {
			isHeaderHidden = false;
		} else if (direction > 0) {
			isHeaderHidden = true;
		} else if (direction < 0) {
			isHeaderHidden = false;
		}

		$body.toggleClass('header-hidden', isHeaderHidden);
	};

	lenis.on('scroll', update);
	update();
};

export { scrollState };
